import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {withTranslation, WithTranslation} from 'react-i18next'
import SimpleTable, {CellData, ColumnsSource, RowData, RowsDataSource, TableData} from './simple-table';
import {EmployeeReport, EmployeesReport} from '../stores/employee-report-store';

interface SchemeReportTableProps extends WithTranslation {
    data: EmployeesReport,
    onDownload?: (format: string) => Promise<boolean>,
    cir: boolean, //if false, then is cii
    time: boolean, 
    cost: boolean,
    elegibility?: boolean,
    hasValues?: (values: boolean) => void,
    currency?: string,
}

interface SchemeReportTableState {
    language: string,
    table: TableData,
    refreh: boolean
}

class SchemeReportTable extends Component<SchemeReportTableProps, SchemeReportTableState> {
    constructor(props: SchemeReportTableProps) {
        super(props);
        this.state = {
            language: props.i18n.language,
            table: this.buildTableData(props.data.projectTaskIdToName, props.data.reports),
            refreh: false
        }
    }

    componentDidUpdate(prev: SchemeReportTableProps) {
        if (this.state.language != this.props.i18n.language) {
            this.setState({
                language: this.props.i18n.language,
                table: this.buildTableData(this.props.data.projectTaskIdToName, this.props.data.reports),
                refreh: true
            })
        }
    }

   
    private parseTime(h:any, format?:any) {
        if (format == null) {
            var hours = parseFloat(h).toFixed(2)
            return `${hours} hrs`
        }
    }
   

    private parseCost(c: any,format?: any) {
        if (format == null) {
            var cost = parseFloat(c).toFixed(2)
            return `${cost}` + this.props.currency
        }
    }

    @autobind
    private buildTableData(projectTaskIdToName: Map<string, string>, reports: EmployeeReport[]): TableData {
        var self = this
        const { t } = this.props
        var tasksIds: string[] = []
        var projectNames: string[] = []
        projectTaskIdToName.forEach((name, id) => {
            tasksIds.push(id)
            projectNames.push(name)
        })
        var rows = [] as any[]
        for (var report of reports) {
            report.workedHoursPerTask.forEach((h, taskid) => {
                if ((this.props.cir && this.props.data.projectIdToCir.get(this.props.data.tasksToProjects.get(taskid)!) && this.props.data.taskIdToCir.get(taskid)) || (!this.props.cir && this.props.data.projectIdToCii.get(this.props.data.tasksToProjects.get(taskid)!) && this.props.data.taskIdToCii.get(taskid))) {
                    rows.push({ title: report.employeeName, cells: [], key: report.employeeId } as RowData)
                    rows[rows.length - 1].cells.push({ value: this.props.data.projectIdToName.get(this.props.data.tasksToProjects.get(taskid)!) })
                    rows[rows.length - 1].cells.push({ value: this.props.data.projectTaskIdToName.get(taskid) })
                    if (this.props.time)
                        rows[rows.length - 1].cells.push({ value: this.parseTime(report.workedHoursPerTask.get(taskid)) })
                    if (this.props.cost)
                        rows[rows.length - 1].cells.push({ value: this.parseCost(report.workedHoursPerTask.get(taskid)! * report.estimatedHourlyCost) })
                }
            })
        }
        var rowsDataSource: RowsDataSource = {
            title: t("Employees"),
            items: rows,
            render: (cell: CellData) => { return <span className={'timesheet-item'} style={{ padding: 5 }}> {cell.value}</span> }
        }

        var columnsSource: ColumnsSource = {
            items: [],
            render: (columnCell) => { return <span style={{ padding: 5 }}> {columnCell.value} </span> }
        }
        columnsSource.items.push({ key: "1", value: t("Project") })
        columnsSource.items.push({ key: "2", value: t("Task") })
        if (this.props.time) {
            columnsSource.items.push({ key: "3", value: t("Time") })
        }
        if (this.props.cost) {
            columnsSource.items.push({ key: "4", value: t("Estimated cost") })
        }

        if (this.props.cir)
            this.props.hasValues!(rowsDataSource.items.length > 0)
        return {
            columnsSource: columnsSource,
            rowsSource: rowsDataSource
        } as TableData
    }

    render() {
        const { t } = this.props;
        if (this.props.data && this.props.data.projectTaskIdToName && this.props.data.reports.length == 0)
            return null
        if (this.state.table.rowsSource.items.length == 0)
            return null
        else
            return <div>
                {this.props.cir ? <h1 style={{ marginBottom: -15 }}>{t('CIR')}</h1> : <h1 style={{ marginBottom: -15 }}>{t('CII')}</h1>}
                <SimpleTable data={this.state.table} elegibility={this.props.elegibility} onDownload={this.props.onDownload} downloadTypeStandard={"perTask-Standard"} downloadTypeMatrix={"perTask-Matrix"} refresh={this.state.refreh} onRefresh={() => this.setState({ refreh: false })} />
            </div>
    }
}
export default withTranslation()(SchemeReportTable);